import { env } from '@/app/env'

export type PlatformEnvironment = 'production' | 'homolog' | 'test'

const PLATFORM_URLS: Record<PlatformEnvironment, string> = {
  production: 'https://app.tractian.com',
  homolog: 'https://app-homolog.tractian.com',
  test: 'https://app-test.tractian.dev'
}

export function buildPlatformUrl(environment: PlatformEnvironment) {
  return PLATFORM_URLS[environment]
}

export function buildCompanyCookie(companyId: string, environment: PlatformEnvironment) {
  const tld = environment === 'test' ? 'dev' : 'com'
  return `companyId=${companyId}; domain=.tractian.${tld}; path=/`
}

export function resolvePlatformEnvironment(value: string): PlatformEnvironment {
  if (value === 'production') return 'production'
  if (value === 'homolog') return 'homolog'
  return 'test'
}

export function redirectToPlatform(params: {
  companyId: string
  environment?: PlatformEnvironment
}) {
  const { companyId, environment = resolvePlatformEnvironment(env.sentryEnvironment) } = params
  document.cookie = buildCompanyCookie(companyId, environment)
  window.open(`${buildPlatformUrl(environment)}/assets`, '_blank', 'noreferrer,noopener')
}

export type PlatformNodeType = 'asset' | 'location'

// Assets: `/assets/:id?v=tree` (same deep link the legacy web app uses).
// Locations: `/locations/:id?v=tree` — assumed to mirror the asset route; not confirmed yet.
export function buildPlatformNodePath(nodeType: PlatformNodeType, platformNodeId: string) {
  const segment = nodeType === 'asset' ? 'assets' : 'locations'
  return `/${segment}/${encodeURIComponent(platformNodeId)}?v=tree`
}

export function redirectToPlatformNode(params: {
  companyId: string
  nodeType: PlatformNodeType
  platformNodeId: string
  environment?: PlatformEnvironment
}) {
  const {
    companyId,
    nodeType,
    platformNodeId,
    environment = resolvePlatformEnvironment(env.sentryEnvironment)
  } = params
  document.cookie = buildCompanyCookie(companyId, environment)
  window.open(
    `${buildPlatformUrl(environment)}${buildPlatformNodePath(nodeType, platformNodeId)}`,
    '_blank',
    'noreferrer,noopener'
  )
}
